// Centralized query keys for React Query
export const serviceOnboardingKeys = {
  // Planner related queries
  planner: {
    createAdminService: () => ['planner', 'create-admin-service'] as const,
    services: (search?: string) =>
      ['planner', 'services', search ?? ''] as const,
    techFamilies: (search?: string) =>
      ['planner', 'tech-families', search ?? ''] as const,
  },
} as const;
